import { ReactNode } from 'react';

export default function SectionHeader({
  title,
  action,
  bordered = false,
}: {
  title: string;
  action?: ReactNode;
  bordered?: boolean;
}) {
  return (
    <div
      className={`d-flex justify-content-between align-items-center px-3 py-2${bordered ? ' border-bottom' : ''}`}
    >
      <span className="fw-bold" style={{ fontSize: 16 }}>
        {title}
      </span>
      {action}
    </div>
  );
}
